import React from "react";

import { FeatureToggleKeys } from "@services/featureToggles.services";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type FeatureSwitchToggleProps = {
    name: FeatureToggleKeys;
    value: boolean;
    onToggle: () => void;
};

const FeatureSwitchToggle = ({
    name,
    value,
    onToggle,
}: FeatureSwitchToggleProps) => {
    const { t } = useGranite();
    return (
        <div className="custom-control custom-switch">
            <input
                type="checkbox"
                className="custom-control-input"
                id={name}
                checked={value}
                onChange={onToggle}
            />
            <label className="custom-control-label" htmlFor={name}>
                {t("featureSwitch." + name) || name}
            </label>
        </div>
    );
};

export { FeatureSwitchToggle };
